export default __webpack_public_path__ + "static/media/Tick.618f4588.svg";